export default __webpack_public_path__ + "static/gopi-de9680e1259d2e700d45c8fa2cceb293.svg";